import { Environment } from "../models/Environment";
import { KrakendCollection, PagedResults } from "../models/generics";
import client from "./axios";

const environmentsUrl = `${window.__env.KRAKEND_URL}/v1/environmentVariables`;
//const environmentsUrl = 'http://localhost:3000/environments';

export const Environments = {
  getEnvironmentVariables: (params?: URLSearchParams) => client.get<PagedResults<Environment> | KrakendCollection<Environment>>(environmentsUrl, { params }),
  createEnvironmentVariable: (environment: Environment) => client.post<Environment>(`${environmentsUrl}`, environment),
  updateEnvironmentVariable: (id: number, environment: Environment) => client.put<Environment>(`${environmentsUrl}/${id}`, environment),
  deleteEnvironmentVariable: (id: number) => client.delete(`${environmentsUrl}/${id}`),
}